import Reflux, { RefluxAction } from "reflux";

const exported = {
    storeSelected: Reflux.createAction("storeSelected") as RefluxAction<[any]>
};

export default exported;

export const { storeSelected } = exported;
